import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import PaymentBody from 'components/payment/PaymentBody';
import paths from 'router/paths';

export const PaymentSuccess = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>Purchase RC-Coin</title>
                <meta name='description' content='Purchase RC-coin success' />
            </Helmet>
            <PaymentBody
                backgroundImageUrl='lutador_shop_main.webp'
                description={`O pagamento foi bem-sucedido.\n O RC que você comprou pode ser usado para adquirir itens na loja do jogo.`}
                buttonText='Histórico de compras de RC'
                link={paths.TOPUP_COIN_HISTORY_PATH}
            />
        </>
    );
};
